import * as util from './syllabus-block-utils';
import Block from './block';

export default {
  props: util.props,
  template: '#pdf-block-template',
  data() {
    return Object.assign({
      title: '',
      file: null,
      removeContent: false,
      contentName: '',
      contentSize: 0,
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.file);
    },
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          file: this.file,
          contentName: this.contentName,
          contentSize: this.contentSize,
          removeContent: this.removeContent,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },
    dzID: util.dzID
  },
  methods: {
    initDropzone() {
      const $el = this.$refs.dzEle;
      const acceptedFiles = '.pdf';
      const maxFilesize = 10;
      const message = JST['templates/dropzone-generic']({
        maxFilesize,
        dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
        dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
        browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
        dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
        maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
        fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
        optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
        acceptedFiles
      });

      const url = Kadenze.Routes.course_syllabus_blocks_path(this.$root.course.id);
      const previewTemplate = JST['templates/dropzone-media-preview']({
        status: this.file ? '' : 'uploading',
        previewable: false
      });
      const opts = {
        url,
        maxFilesize,
        maxFiles: 1,
        paramName: 'file',
        acceptedFiles,
        previewTemplate,
        autoProcessQueue: true,
        previewable: false,
        playable: false,
        accept: (file, done) => {
          if ( file.size === 0 ) {
            done('Please make sure file is not empty.');
          } else { done(); }
        }
      };
      const callbacks = {
        uploadprogress: (file, progress, bytesSent) => {
          $('.media-upload-progress-bar', file.previewTemplate).css('width', progress + '%');
        },
        success: (file, { block }) => {
          this.bindFile(file, block);
          this.$emit('set-block-id', { uuid: this.uuid, id: block.id });
        },
        error: (file, errorMessage) => {
          new Kadenze.Notice.error({ message: errorMessage });
          $el.dropzone.removeAllFiles();
        },
        removedFile: () => {
          this.file = null;
          this.removeContent = true;
        },
        complete: (file) => {
          $('.media-upload-progress-bar-container', file.previewTemplate).hide();
          $('.label-uploading', file.previewTemplate).hide();
        }
      };

      new Kadenze.MediaDropZone($el, $(message), opts, callbacks, false, this.curFileObj() );
    },
    bindFile: util.bindFile,
    curFileObj: util.curFileObj
  },
  mounted() {
    this.initDropzone();
  },
};
